import { CloseoutActivity } from "../../Schedule/Scheduler/CloseoutDrawer/Tabs/CloseoutActivity/CloseoutActivity";
import { useWorkOrderAttemptDrawerActivityViewModel } from "./useWorkOrderAttemptDrawerActivityViewModel";

export const WorkOrderAttemptDrawerActivity = ({ attempt, stateManager }) => {
  const { attemptActivities, getAttemptActivities } =
    useWorkOrderAttemptDrawerActivityViewModel({
      attempt,
      stateManager,
    });

  return (
    <CloseoutActivity
      open
      attemptModifiedOn={attempt?.modifiedOn || ""}
      activities={attemptActivities || []}
      getAttemptActivities={getAttemptActivities}
    />
  );
};
